export default {
  payment: "Pago",
  paymentMethods: "Métodos de pago",
  to: "al",
  changeLanguage: "Change language",
  checkByPhoto: "Cheque por foto",
  replace: "Reemplace",
  pleaseConfirmCheckAmount: "Confirme que el monto del cheque sea igual a {amount} y envíelo",
  confirmCheckAmountAndSubmit: "Confirmar {amount} y enviar",
  submittedSuccessfully: "Enviado con éxito",
  // Pay by card
  payWithCard: "Tarjeta",
  payWithAch: "Transferencia Bancaria",
  fillInCardDetails: "Rellene los datos de la tarjeta",
  pleaseSignHere: "Firme aquí por favor",
  pleaseSignHereAutoSubmit: "Firme aquí (se enviará el formulario)",
  clearSignature: "Borrar",
  noTip: "Sin propina",
  agreePayAboveAmount: "Estoy de acuerdo en pagar la cantidad anterior",
  agreePayAboveAmountFirst: "Estoy de acuerdo con",
  agreePayAboveAmountUrl: "política de la compañía",
  agreePayAboveAmountLast: "y a abonar el importe anterior, que no es reembolsable",
  grossAmount: "Cantidad bruta",
  nonCashAdj: "Ajuste no en efectivo",
  cashCheckPrice: "Precio en efectivo/cheque",
  pay: "Pagar",
  processing: "Procesando...",
  loading: "Cargando...",
  couldNotProcess: "No se ha podido procesar el pago de este pedido",
  noPaymentMethod: "Póngase en contacto con el comerciante. No hay métodos de pago activos disponibles",
  buyNowPayLaterButton: "Compra y paga luego (Klarna)",
  withTipAmount: "Importe total con propinas",
  firstName: "Nombre",
  lastName: "Apellido",
  routing: "Número de ruta",
  accountNumber: "Número de cuenta",
  // Zelle Pay
  payByBankApp: "App Bancaria",
  sendMoney: "Enviar Dinero",
  withBankAppTo: "con App Bancaria a:",
  at: "en:",
  invoice: "Factura:",
  amount: "Monto:",
  instructionStep1: "1. Copia el ID y pégalo o introdúcelo en tu app bancaria.",
  instructionStep2: "3. Copie el monto y pégue en su app bancaria",
  instructionStep3WithInvoice: "4. Copie # de factura y pégue en el campo memo",
  idCopied: "ID copiado al portapapeles",
  displayNameCopied: "Nombre de empresa copiado al portapapeles",
  invoiceCopied: "Factura copiada al portapapeles",
  amountCopied: "Monto copiado al portapapeles",
  instructionStepDisplayName: "2. Copie el nombre de la empresa y pégue en su app bancaria"
}
